module.exports = __webpack_public_path__ + "static/media/malcantone.ae10c230.jpg";